import actionTypes from './actionTypes'

const mainTopbarActions = {
	initialize() {
		return {
			type: actionTypes.MAIN_TOPBAR_INITIALIZE,
		}
	},
	logoSelected() {
		return {
			type: actionTypes.MAIN_TOPBAR_LOGO_SELECTED,
		}
	},
	homeSelected() {
		return {
			type: actionTypes.MAIN_TOPBAR_HOME_SELECTED,
		}
	},
	homeSelectedFailed() {
		return {
			type: actionTypes.MAIN_TOPBAR_HOME_SELECTED_FAILED,
		}
	},
	plusIconToggled() {
		return {
			type: actionTypes.MAIN_TOPBAR_PLUS_ICON_TOGGLED,
		}
	},
	quickLaunchIconToggled() {
		return {
			type: actionTypes.MAIN_TOPBAR_QUICK_LAUNCH_ICON_TOGGLED,
		}
	},
	createLesson() {
		return {
			type: actionTypes.MAIN_TOPBAR_CREATE_LESSON,
		}
	},
	createGoogleDriveLesson() {
		return {
			type: actionTypes.MAIN_TOPBAR_CREATE_GOOGLE_DRIVE_LESSON,
		}
	},
	createInteractiveVideo() {
		return {
			type: actionTypes.MAIN_TOPBAR_CREATE_INTERACTIVE_VIDEO,
		}
	},
}

export default mainTopbarActions
